import React, { useState } from 'react';
import EventInfoTile from './tiles/EventInfoTile';
import CreateBookingModal from './modals/CreateBookingModal';
import ClientsTable from './tables/ClientsTable';
import BusinessClientContainer from './BusinessClientContainer'; 
import 'react-tabs/style/react-tabs.css';
import { useEffect } from 'react';


const Clients = ({ clientRecord, onEventClick, setInitialBusinessEventTab }) => {

    const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectedClient, setSelectedClient] = useState(null); // ✅ State to track selected client
    
    useEffect(() => {
        if (clientRecord) {
            setSelectedClient(clientRecord._id);
        }
    }, [clientRecord]); 


    const closeModal = () => {
        setIsModalOpen(false);
    };


    const handleClientSelect = (clientData) => {
        setSelectedClient(clientData); 
    };

    return (
        <div>
            <div style={{width: '98%'}}>

                {/* Conditionally render either table+tile or business container */}
                {!selectedClient ? (
                    <>
                       <h1 style={{ color: '#1C1154', margin: '30px', marginLeft: '0px', marginTop: '20px' }}>Clients</h1>
                        <EventInfoTile />
                        <ClientsTable handleClientClick={handleClientSelect} />
                    </>
                ) : (
                    <BusinessClientContainer clientId={selectedClient} onEventClick={onEventClick} setInitialBusinessEventTab={setInitialBusinessEventTab}/>
                )} 
            </div>

            <CreateBookingModal
                isModalOpen={isModalOpen}
                closeModal={closeModal}
            />
        </div>
    );
};

export default Clients;
